import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ForgetPasswordPage } from './forget-password';

@NgModule({
  declarations: [
    ForgetPasswordPage,
  ],
  imports: [
    IonicPageModule.forChild(ForgetPasswordPage),
  ],
})
export class ForgetPasswordPageModule {}



// WEBPACK FOOTER //
// ./src/pages/forget-password/forget-password.module.ts